export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";